const isValidPhone = (phone) => {
    const phoneRegex = /^\+91[789]\d{9}$/;
    return phoneRegex.test(phone);
}

export default isValidPhone;